// @ts-nocheck - formatter / Table
import React, { useState } from 'react';
import { loadSoldTransactionSkus } from '../../../actions/keyCodeActions';
import { NavLink, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../common/Table';
import { CommaNumber_NoDecimal } from '../../../util/formatter';
import Loading from '../../common/Loading';
import KwPanel from '../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../hooks/useTableSettings';
import CompanyLink from '../../common/links/CompanyLink';
import { useTranslation } from 'react-i18next';

export interface ReportedSoldTransactionSkusListProps {
  id?: string;
  reload?: any;
}

function ReportedSoldTransactionSkusList({ id, reload }: ReportedSoldTransactionSkusListProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const allColumns = ['game', 'keyCount', 'companyName'];
  const defaultVisibleColumns = allColumns;
  const [transactions, setTransactions] = useState<any>();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'reportedsoldtransactionskuslist-settings',
      getTableSettingsDefaults({
        defaultSort: 'game',
        defaultVisibleColumns,
      }),
      { id },
      loadSoldTransactionSkus,
      setTransactions,
      reload,
      t('Failed to load sold transaction Skus')
    );

  let columnsConfig = [
    {
      Key: 'game',
      Label: t('Game'),
      width: '40%',
      Render: (item: any) => (
        <>
          <NavLink to={`/sku/${item.skuId}`} className="game-title">
            {item.game}
          </NavLink>
          <br />
          <NavLink to={`/sku/${item.skuId}`}>{item.sku}</NavLink>
        </>
      ),
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'keyCount',
      Label: t('Key count'),
      width: '20%',
      className: 'text-right num no-wrap',
      Render: (item: any) => CommaNumber_NoDecimal(item.keyCount),
    },
    {
      Key: 'companyName',
      Label: t('Company'),
      width: '40%',
      Render: (item: any) => (
        <CompanyLink
          id={item.companyId}
          name={item.companyName}
          fallbackText={t('--- unknown ---')}
        />
      ),
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
  ];

  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  return transactions ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={transactions.data.map((x: any) => ({ Key: x.id, ...x }))}
        totalRowCount={transactions.totalRowCount}
        filteredRowCount={transactions.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filterChange={filterChange}
      />
    </KwPanel>
  ) : (
    <Loading />
  );
}

export default ReportedSoldTransactionSkusList;
